export interface UserContact {
  '@id'?: string;
  type?: number;
  label?: string;
  source?: string;
  customType?: string;
  category?: string;
  value?: string;
  structured?: any;
  user?: any;
  sleepSame?: boolean;
  combined?: any;
  readonly deletedAt?: Date;
  readonly createdAt?: Date;
  readonly updatedAt?: Date;
  readonly confirmedAt?: Date;
  readonly address?: string;
  readonly road?: string;
  readonly area?: string;
  readonly otherArea?: string;
  readonly cnpCode?: string;
  readonly buildingId?: string;
  readonly schemaType?: number;
  readonly displayLabel?: string;
}

// public const TYPE_ADDRESS = 1;
// public const TYPE_EMAIL = 2;
// public const TYPE_PHONE = 3;
// public const TYPE_MOBILE = 4;
// public const TYPE_EMERGENCY_NUMBER = 5;
// public const TYPE_EMERGENCY_PERSON = 6;
// public const TYPE_EMERGENCY_RELATIONSHIP = 7;
// public const TYPE_EMERGENCY_RELATIONSHIP_OTHER = 8;
// public const TYPE_CUSTOM = 100;

export const UserContactType = {
  ADDRESS: 1,
  EMAIL: 2,
  PHONE: 3,
  MOBILE: 4,
  EMERGENCY_NUMBER: 5,
  EMERGENCY_PERSON: 6,
  EMERGENCY_RELATIONSHIP: 7,
  EMERGENCY_RELATIONSHIP_OTHER: 8,
  CUSTOM: 100,
} as const;
